import { obtenerSolicitudTipoId, SolicitudTiposEnum } from "./solicitud-tipos.enum";

const obtenerOcrearComplemento = (clave: SolicitudTiposEnum, complementos: any[]) => {
  let comp = complementos.find((c) => c[clave]);
  if (!comp) {
    comp = {};
    comp[clave] = [];
    complementos.push(comp);
  }
  return comp[clave];
};

export const mapearASolicitudDocumentos = (
  solicitudTipo: SolicitudTiposEnum,
  documentosFormulario: object,
  acreditaCM = false,
  crearComplementoVacio = false
): Array<any> => {
  if (!documentosFormulario) return [];

  const complementos: any = [];

  if (crearComplementoVacio && Object.keys(documentosFormulario).length === 0) {
    const complementoVacio = {};
    complementoVacio[solicitudTipo] = [];
    complementos.push(complementoVacio);
    return complementos;
  }

  const documentosItems = Object.keys(documentosFormulario);

  documentosItems.forEach((key) => {
    if (key.toLowerCase() === "null") return;
    const documentoFormulario = documentosFormulario[key];
    if (!documentoFormulario) return; // Ignorar valores nulos reales
    const documento = {
      ...documentoFormulario,
      idDocumento: key,
      nombre: documentoFormulario.nameFile,
      idTipoDocumento: documentoFormulario.idForm,
      idTipoTransaccion: obtenerSolicitudTipoId(solicitudTipo),
    };
    delete documento.nameFile;
    delete documento.idForm;

    const esDocumentoDeCuotaMonetaria = key === "certificadoEscolar";
    const tipo = esDocumentoDeCuotaMonetaria ? SolicitudTiposEnum.ACM : solicitudTipo;
    const destino = obtenerOcrearComplemento(tipo, complementos);
    destino.push(documento);
  });

  if (acreditaCM && !complementos.find((c) => c[SolicitudTiposEnum.ACM])) {
    const acm = {};
    acm[SolicitudTiposEnum.ACM] = [];
    complementos.push(acm);
  }

  return complementos;
};

export const agregarDocumentoRNEC = (
  solicitudTipo: SolicitudTiposEnum,
  documentoRNECB64: string,
  complementos: Array<any>,
  esRnecParentesco = false,
  esTitular = false,
) => {
  if (!documentoRNECB64) return;

  const destino = obtenerOcrearComplemento(solicitudTipo, complementos);

  const crearDocumento = (id: string, nombreBase: string, idTipo: number) => {
    if (!documentoRNECB64) return null;

    const nombre = esTitular
      ? nombreBase.replace(".pdf", "_titular.pdf")
      : nombreBase;

    return {
      idTipoDocumentoDigital: idTipo,
      base64: documentoRNECB64,
      revisionManual: false,
      pathDocumentoDigital: "",
      esDocumentoDigital: false,
      idDocumento: id,
      nombre,
      idTipoDocumento: idTipo,
      idTipoTransaccion: obtenerSolicitudTipoId(solicitudTipo),
    };
  };

  if (esRnecParentesco) {
    const docHijo = crearDocumento("docRnecHijo", "rnecHijo.pdf", 18);
    destino.push(docHijo);
  }
  const docUnico = crearDocumento("rnec", "soporte_digital_RNEC.pdf", 16);
  destino.push(docUnico);
};

export const agregarDocumentosNoExigibles = (
  solicitudTipo: SolicitudTiposEnum,
  documentos: Array<any>,
  complementos: Array<any>
) => {
  if (!documentos) return;

  documentos.forEach((documentoAfiliado) => {
    const documentoTransformado = {
      idTipoDocumentoDigital: documentoAfiliado.idTipoDocumento,
      base64: "",
      revisionManual: false,
      pathDocumentoDigital: documentoAfiliado.nombre,
      idTipoTransaccion: obtenerSolicitudTipoId(solicitudTipo),
      esDocumentoDigital: true,
      idDocumento: documentoAfiliado.idForm,
      nombre: documentoAfiliado.label,
      idTipoDocumento: documentoAfiliado.idTipoDocumento,
    };

    const destino = obtenerOcrearComplemento(solicitudTipo, complementos);
    destino.push(documentoTransformado);
  });
};
